const SNAKE_CASE_MATCH = /_\w/g;

/**
 * Converts an underscore_string to a camelCase string
 * @param {string} key String to convert
 */
export const snakeToCamel = (key) =>
    key.replace(SNAKE_CASE_MATCH, (chars) => chars[1].toUpperCase());
